import { memo } from 'react';

import { Option } from '@/shared/types/rules';
import { LENGTH_XXL } from '@/util/validation/constants';

import { ToolkitEditor } from '../ToolkitEditor/ToolkitEditor';

interface EditorWrapperProps {
  content: string;
  onContentChange: (content: string) => void;
  variableOptions: Option[];
  placeholder?: string;
}

/**
 * Memoized editor wrapper to prevent rerenders when selector changes
 */
export const EditorWrapper = memo(
  ({ content, onContentChange, variableOptions, placeholder }: EditorWrapperProps) => (
    <ToolkitEditor
      content={content}
      onContentChange={onContentChange}
      variableOptions={variableOptions}
      placeholder={placeholder}
      maxLength={LENGTH_XXL}
    />
  )
);
EditorWrapper.displayName = 'EditorWrapper';
